// Test IDs for portfolio sections
export const PORTFOLIO = {
    // nav
    navLogo: 'nav-logo',
    navLinkWork: 'nav-link-work',
    navLinkAbout: 'nav-link-about',
    navLinkPhilosophy: 'nav-link-philosophy',
    navLinkContact: 'nav-link-contact',
    navCta: 'nav-cta',
    // hero
    heroSection: 'hero-section',
    heroHeadline: 'hero-headline',
    heroSubtitle: 'hero-subtitle',
    heroScrollCue: 'hero-scroll-cue',
    heroAvailability: 'hero-availability',
    // about
    aboutSection: 'about-section',
    aboutBio: 'about-bio',
    aboutToolFigma: 'about-tool-figma',
    aboutToolAdobeXd: 'about-tool-adobe-xd',
    aboutToolHtml: 'about-tool-html',
    aboutToolCss: 'about-tool-css',
    aboutToolJs: 'about-tool-js',
    aboutToolJquery: 'about-tool-jquery',
    aboutYears: 'about-years',
    aboutProjectsCount: 'about-projects-count',
    // projects
    projectsSection: 'projects-section',
    projectCard: (slug) => `project-card-${slug}`,
    projectLink: (slug) => `project-link-${slug}`,
    projectsViewAll: 'projects-view-all',
    // philosophy
    philosophySection: 'philosophy-section',
    philosophyQuote: 'philosophy-quote',
    // marquee
    marqueeSection: 'marquee-section',
    // contact
    contactSection: 'contact-section',
    contactEmail: 'contact-email',
    contactSocialLinkedin: 'contact-social-linkedin',
    contactSocialDribbble: 'contact-social-dribbble',
    contactSocialBehance: 'contact-social-behance',
    contactSocialX: 'contact-social-x',
    contactCtaButton: 'contact-cta-button',
    // footer
    footerYear: 'footer-year',
};
